import { render, staticRenderFns } from "./CwcIconButton.vue?vue&type=template&id=4846d916"
import script from "./CwcIconButton.vue?vue&type=script&lang=js"
export * from "./CwcIconButton.vue?vue&type=script&lang=js"
import style0 from "./CwcIconButton.vue?vue&type=style&index=0&id=4846d916&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports